import React from 'react';

import {connect} from "react-redux";

import {Grid} from "@material-ui/core";
import {useSelectedItems} from "../../../../hooks/useSelectedItems";
import {PRODUCT_TYPE, PRODUCTS_TO_COMPARE_MAX_COUNT} from "../../../ProductComparison/constants";
import {displayErrorSnackBar} from "../../../../components/SnackbarProvider/actions";
import {PrimaryButton} from "../../../../components/Buttons";

import {
  useAddProductsToComparisonContext, useCustomerInstrumentsDataContext
} from "../../../../components/SelectForProductsComparisonModal/SelectForProductsComparisonModal";
import DepotSelectionModal from "../DepotSeletionModal";


const IDENTIFIER_KEY = 'data.uniq_id';


export const SelectCustomerDepotsForProductsComparisonModal = connect()(({customerId, onClose, dispatch, open}) => {

  const {onAddProductsToComparison, comparisonStartedTrigger} = useAddProductsToComparisonContext();
  const instrumentsData = useCustomerInstrumentsDataContext();

  const depots = React.useMemo(() => {
    return (instrumentsData.data || []).filter((depot) => !depot.not_connected)
  }, [instrumentsData.updatedAt]);

  const {selectedItems, handleToggleItem, handleSelectMany, handleUnselectMany, cleanSelected} = useSelectedItems(IDENTIFIER_KEY);

  const selectedInstruments = Object
    .values(selectedItems)
    .filter((product) => product.productType === PRODUCT_TYPE.ASSET);

  React.useEffect(() => {
    if (!!comparisonStartedTrigger) {
      onClose();
      cleanSelected();
    }
  }, [comparisonStartedTrigger]);

  const handleContainerCheckboxChange = (depot) => {
    handleToggleItem({data: {...depot, customer_id: customerId, uniq_id: depot.id}, productType: PRODUCT_TYPE.CUSTOMER_PORTFOLIO}, IDENTIFIER_KEY);
  };

  const handleInstrumentSelect = (instrument, depot) => {
    handleToggleItem({data: instrument, productType: PRODUCT_TYPE.ASSET, depotId: depot.id}, IDENTIFIER_KEY);
  };

  const handleSelectAllInstruments = (depot, depotInstruments) => {
    const depotSelectedInstruments = Object
      .values(selectedItems)
      .filter((product) => product.productType === PRODUCT_TYPE.ASSET && product.depotId == depot.id);
    const handler = depotInstruments.length === depotSelectedInstruments.length
      ? handleUnselectMany : handleSelectMany;

    handler(depotInstruments.map((instrument) => ({
      data: instrument,
      productType: PRODUCT_TYPE.ASSET,
      depotId: depot.id
    })), IDENTIFIER_KEY);
  };

  const handleAddProductsToComparison = (isNewComparison) => () => {

    const uniqProductsMap = {};
    Object
      .values(selectedItems)
      .forEach((product) => {
        const productKey = product.productType == PRODUCT_TYPE.ASSET
          ? product.data.isin
          : product.data.id;
        uniqProductsMap[productKey] = product;
      });

    const uniqProducts = Object.values(uniqProductsMap);

    if (uniqProducts.length > PRODUCTS_TO_COMPARE_MAX_COUNT) {
      dispatch(displayErrorSnackBar('Maximale Anzahl von 10 Produkten erreicht.'));
      return;
    }

    onAddProductsToComparison(uniqProducts, isNewComparison)
  };

  if (!open) {
    return null
  }

  const actionsDisabled = !Object.keys(selectedItems).length;

  return (
    <DepotSelectionModal
      open={open}
      onClose={onClose}
      title={'Vergleich'}
      subHeader={'Wählen Sie ganze Depots oder einzelne Instrumente innerhalb der Depots, um bis zu 10 Produkte an den Investmentvergleich zu übergeben.'}
      instrumentsData={instrumentsData}
      depots={depots}
      selectedItems={selectedItems}
      handleContainerCheckboxChange={handleContainerCheckboxChange}
      handleSelectAllInstruments={handleSelectAllInstruments}
      handleInstrumentSelect={handleInstrumentSelect}
      selectedInstruments={selectedInstruments}
      actions={
        <>
          <Grid xs={12} sm={"auto"} item>
            <PrimaryButton
              text='Zu Investmentvergleich hinzufügen'
              disabled={actionsDisabled}
              onButtonClick={handleAddProductsToComparison(false)}
              style={{width: '100%'}}
            />
          </Grid>
          <Grid xs={12} sm={"auto"} item>
            <PrimaryButton
              text='Neuer Investmentvergleich starten'
              disabled={actionsDisabled}
              onButtonClick={handleAddProductsToComparison(true)}
              style={{width: '100%'}}
            />
          </Grid>
        </>
      }
    />
  )
});